import { AboutMedia } from '@/about/media';
import { Layout } from '../../libs/layout';

export const AboutUs = {

    $tabContent : $('#AboutUsTabContent'), // container
    $tabs : $('#about-us-tab a.tab-link'),
    $activeTab : $('#about-us-tab a.tab-link.active'),

    init() {
        this.secondaryMenu();
        this.tabEventListener();
        this.activateTab();
        this.loadTabContents();
    },

    /**
     * Set secondary menu as tab
     */
    secondaryMenu() {
        // Add the target tab-pane
        this.$tabs.each(function() {
            let $this = $(this);
            $this.attr('data-bs-target', `#${$this.attr('id')}-tab-pane`);
        })
        // Activate BS tab
        .click(function(e) {
            e.preventDefault();
            let $this = $(this);
            $this.tab('show');
            Layout.slideToElement('body', 200);
            window.history.pushState({}, $this.text(), $this.attr('href'));
        });
    },
    /**
     * Activate tab on page load
     */
    activateTab() {
        $(`#${this.$activeTab.attr('id')}-tab-pane`).addClass('show active');
    },

    loadTabContents() {
        let self = this;
        this.$tabs.not('.active').each(function() {
            let $this = $(this);
            let url = `${$this.attr('href')}/layout:ajax`;
            $.ajax({url}).done(function(response) {
                self.$tabContent.append(
                    $(response).find('div.tab-content').html()
                );

                self.afterAjaxLoadContent($this.attr('id'));
            });
        });
    },

    /**
     * Attach events after content load via ajax
     */
    afterAjaxLoadContent(id) {
        switch (id) {
            case 'in-the-news':
                AboutMedia.render();
                break;
        }
    },

    /**
     * Open/show the tab
     */
    tabEventListener() {
        $('body').on('click', '[data-tab]', function(e) {
            e.preventDefault();
            $($(this).data('tab')).click();
        });
    }


}